import React from 'react';

import { ReviewProvider } from '@hydra/common/context/review';

import HeaderFooterShell from '@hydra/common/shell/HeaderFooterShell';

import ReviewTeaserPage from '@hydra/common/components/ReviewTeaserPage';
import ReviewGeneration from '@hydra/common/components/ReviewGeneration';
import ReviewMetaData from './ReviewMetaData';
import { ReviewInterface } from '@hydra/types/review';

import { useTheme, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: { display: 'flex', flexDirection: 'column' }
});

interface TeaserReviewContainerProps {
  data: {
    review?: ReviewInterface
    url?: string
    generationId?: string
  },
  match: any
}

const ALLOWED_VARIANTS: string[] = ['noadvice', 'nocrit'];

export default function TeaserReviewContainer ({ data = {}, match: { location: { query } } }: TeaserReviewContainerProps) {
  const variant = (query?.variant && ALLOWED_VARIANTS.includes(query.variant)) ? query.variant : null;
  const theme = useTheme();
  const classes = useStyles();
  const {
    review,
    url,
    generationId
  } = data;

  return (
    <ReviewProvider
      isFree
      isReviewTeaser
      hasReviewTeaserUrl
      variant={variant}
    >
      <ReviewMetaData url={url || ''} screenshot={(review && review.screenshot) || ''} isFree />
      <HeaderFooterShell
        className={classes.root}
        bgColor={theme.palette.background.secondary}
        hideFooter={!!generationId}
        FooterProps={{ small: false }}
      >
        {generationId
          ? <ReviewGeneration url={url} generationId={generationId} />
          : <ReviewTeaserPage data={data} />}
      </HeaderFooterShell>
    </ReviewProvider>
  );
}
